export const download = {
  pathname: '/api/v4/ttp/download',
  headers: {
    'Content-Type': 'application/json',
    accept: 'text/csv'
  },
  method: 'POST',
  body: body => {
    if (typeof body !== 'object' || body === null) {
      throw new Error('ttps.download requires an object')
    }
    return body
  }
}
